export default "__VITE_ASSET__f8db828b__"